
const HelperFile = {
	
	byteLength: ( str ) => {
		// returns the byte length of an utf8 string
		let s = str.length;
		for (let i=str.length-1; i>=0; i--) {
			const code = str.charCodeAt(i);
			if (code > 0x7f && code <= 0x7ff) s++;
			else if (code > 0x7ff && code <= 0xffff) s+=2;
			if (code >= 0xDC00 && code <= 0xDFFF) i--; //trail surrogate
		}
		return s;
	},
	
	formatBytes: ( bytes, decimals = 2 ) => {
		if (bytes === 0) return '0 Bytes';
		
		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
}

export default HelperFile
